import React from "react"
import styled from "styled-components"
import TargetIcon from "../../assist/icons/about/target.svg"
import Targetsinfo from "./Targetsinfo"
import vision from "../../assist/icons/about/vision.svg"
import strategy from "../../assist/icons/about/strategy.svg"
import values from "../../assist/icons/about/values.svg"
import TargetSlid from "./TargetSlid"
const Targets = ({ lang }) => {
  const targetWords = [
    {
      icon: strategy,
      ar: {
        title: " استراتيجيتنا",
        desc: `
          التواجد الفعال على الأرض لتحدید احتیاجات المجتمعات المتضررة ,الاعتماد على الکفاءات البشریة المتاحة والعمل على تطویرها, لاستخدامها بالشکل الأمثل
          `,
      },
      en: {
        title: "Our Strategy",
        desc:
          "Active presence on the ground to identify the needs of affected communities. Relying on the available human resources and developing them continuously to utilize them optimally.",
      },
      tr: {
        title: "Stratejimiz",
        desc: `
        Zarar görmüş toplulukların ihtiyaçlarını  belirlemek için sahada aktif bir şekilde rol almak.
        en iyi şekilde vazifelendirmek için Mevcut inasan kaynaklarına güvenmek ve onları 
        aralıksız geliştirmeye çalışmak.
        `,
      },
    },
    {
      icon: values,
      ar: {
        title: ":قيمنا",
        desc: "التعاون، المصداقية، االحترافية، الشفافية، الحيادية، المبادرة",
      },
      en: {
        title: "Our Values",
        desc:
          "Cooperation, Credibility, Professionalism, Transparency, Neutrality, and Initiative",
      },
      tr: {
        title: "Değerlerimiz",
        desc: `
          Yardımlaşma . Dürüstlük . Profesyonellik. Şeffaflık . Tarafsızlık , Girişimcilik 
          `,
      },
    },
    {
      icon: vision,
      ar: {
        title: ":رؤيتنا",
        desc:
          "الوصول إلی عالم یتمکن فیه جمیع الناس من ممارسة حقهم في الحیاة وفقاً لإرادتهم في الکرامة والعدالة والتحرر من الجوع والفقر",
      },
      en: {
        title: "Our Vision",
        desc:
          "Creating an environment in which all individuals can exercise their right willingly to live in dignity, justice and getting rid of hunger and poverty.",
      },
      tr: {
        title: `Vizyonumuz `,
        desc:
          "Tüm insanların haysiyet ve adelet çerçevesi içerisinde , açlık ve yoksulluktan özgürleşmiş olarak kendi isteklerine bağlı yaşam haklarını Kullanabilecekleri bir dünyaya ualşmak.",
      },
    },
  ]
  const words = {
    ar: {
      targetName: "أهدافنا",
      targetParg: `
      تعزیز البیئة الوقائیة من خلال تعزیز قدرات المجتمعات المحلیة وآلیات
      التکیف. توفیر وتحسین المرافق الصحیة والصرف الصحي. تحسین سبل العیش
      للمجتمع. تحسین التعلیم في مخیمات النازحین
      `,
    },
    en: {
      targetName: "Our Goals",
      targetParg: `
      Improving the protective environment by strengthening the capacities of local communities and coping mechanisms. Providing and improving sanitation facilities. Improving the livelihoods of the community. Improving education in IDPs camps.
      `,
    },
    tr: {
      targetName: "Hedeflerimiz",
      targetParg: `
      Önleyici çevreyi güçlendirmek amacıyla yerel toplumların  yeteneklerini desteklemek. 
      Sağlık tesisatlarını ve kanalizasyon  ağlarını temin etmek ve geliştermek.
      Toplumun geçim kaynaklarını iyileştirmek. 
      Yerinden edilen kişilerin kamplarında eğitimi iyileştirmek.
      
      `,
    },
  }

  return (
    <Wraper>
      <div className="container">
        <div className="content aboutFontSize">
          <img src={TargetIcon} alt="target icon" className="aboutPageLogo" />
          <h3 className="aboutPageTitle">{words[lang].targetName}</h3>
          <p>{words[lang].targetParg}</p>

          <Targetsinfo targetWords={targetWords} lang={lang}/>
          <div className="targetsSlid">
            <TargetSlid targetWords={targetWords} lang={lang} />
          </div>
        </div>
      </div>
    </Wraper>
  )
}

export default Targets

const Wraper = styled.div`
  background: ${props => props.theme.aboutback};
  text-align: center;
  padding-bottom: 45px;

  .content {
    .targetsSlid {
      display: none;
    }

    @media (max-width: 800px) {
      font-size: 1rem;
    }
    @media (max-width: 650px) {
      .targetsSlid {
        display: block;
      }
    }
  }
`
